module.exports = __webpack_public_path__ + "static/media/zara_en.13d73db8.png";